import React, { FC } from 'react';
import { Grow, Chip } from '@mui/material';
import { MaterialSymbol } from '@/components/MaterialSymbol';
import { ChildrenProp } from '@/declarations/ChildrenProp';
import { DamsMediaItem } from '@/declarations/models/DamsMediaResponse';
import Container from '../../../../../components/Container';
import HeaderThumbnail from './HeaderThumbnail';
import HeaderTitle from './HeaderTitle';

export interface DamsHeaderProps {
  open: boolean;
  item: DamsMediaItem;
}

export const DamsHeader: FC<DamsHeaderProps & ChildrenProp> = ({ children, open = true, item }) => {
  const title = 'title' in item ? item?.title || '' : '';

  return (
    <Container left fullWidth>
      <HeaderThumbnail item={item} hidden={open} alt={('title' in item && item?.title) || ''} />
      <Container column left fullWidth>
        <Container gap={1} left fullWidth>
          <Container left column gap={0.5}>
            <Chip
              size='small'
              sx={{ marginLeft: '0.5em', fontSize: '0.7em', backgroundColor: '#785AAC', color: '#fff' }}
              label='DAMS'
            />
            <HeaderTitle title={('title' in item && item?.title) || ''} />
          </Container>
        </Container>
        <Container px={1}>{children}</Container>
      </Container>
    </Container>
  );
};

export default DamsHeader;
